import { useState } from 'react';
import { ExportCsvButton } from './BackofficeLayout.styled';

interface ExportButtonProps {
  readonly onExport: () => Promise<void>;
  readonly label?: string;
}

const DownloadIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z" />
  </svg>
);

const ExportButton: React.FC<ExportButtonProps> = ({ onExport, label = 'Export CSV' }) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setLoading(true);
    try {
      await onExport();
    } catch {
      // errors are expected to be handled by the onExport callback
    } finally {
      setLoading(false);
    }
  };

  return (
    <ExportCsvButton $loading={loading} disabled={loading} onClick={handleClick}>
      <DownloadIcon />
      {loading ? 'Exporting...' : label}
    </ExportCsvButton>
  );
};

export default ExportButton;
